import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";

import ExpandableSearch from "components/atoms/ExpandableSearch/ExpandableSearch";

type GlobalTableSearchProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey?: string;
  eventContext: string; // eslint-disable-line react/no-unused-prop-types
};

function GlobalTableSearch(props: GlobalTableSearchProps) {
  const { currentFilters, filterKey, setFilters } = props;
  const [inputValue, setInputValue] = useState("");

  const handleChange = useAsyncDebounce((value: string) => {
    if (filterKey) {
      setFilters({
        ...currentFilters,
        [filterKey]: value,
      });
    } else {
      setFilters(value);
    }
  }, 500);

  return (
    <ExpandableSearch
      value={inputValue}
      onChange={(e) => {
        handleChange(e.target.value);
        setInputValue(e.target.value);
      }}
    />
  );
}

export default GlobalTableSearch;

GlobalTableSearch.defaultProps = {
  filterKey: undefined,
};
